import { phpRequest } from "./phpRequest";

export const resetPasswordtoAPI = (passwords) => {
  const oldPassword = passwords.oldPassword;
  const newPassword = passwords.newPassword;

  return phpRequest.post("/member/reset-password", {
    old_password: oldPassword,
    new_password: newPassword,
  });
};
